import ListTemplate from 'components/template/ListTemplate';
import React, { FC, useCallback, useContext, useMemo } from 'react';
import { useHeader } from './hooks/useHeader';
import { useQueryPermissions } from './hooks/useQueryPermissions';
import { useQuerySubscriptionFilter } from './hooks/useQuerySubscriptionFilter';
import { useTotalEntregadorEscalado } from './hooks/useTotalEntregadorEscalado';
import { useTransformColeta } from './hooks/useTransformColeta';
import { ModalInfoPlayer } from '../../../components/infoPlayer';
import { AuthContext } from 'routes/auth.context';
import { useMutation } from '@apollo/client';
import { GRAPHQL_ALTERAR_TIPO_RECIPIENTE_ENTREGA } from 'gql/coleta';
const ListCollection: FC<any> = () => {
    const totalEscalado = useTotalEntregadorEscalado();
    const permissoes = useQueryPermissions({
        searchResourceId: 'lista-coleta',
        action: 'editar',
    });
    const props = useQuerySubscriptionFilter();
    const colunas = useHeader();
    const { configuracao, unidadeSelecionada } = useContext(AuthContext);
    const [alterarTipoRecipienteEntrega] = useMutation(GRAPHQL_ALTERAR_TIPO_RECIPIENTE_ENTREGA);
    const onToggleRecipiente = useCallback(async (coletaId: string, newTipo: string) => {
        if(!confirm(`Deseja alterar o tipo do recipiente para ${newTipo === 'bau' ? 'Baú' : 'Bag'}?`)) return;
        try {
            await alterarTipoRecipienteEntrega({
                variables: {
                    coletaId,
                    tipoRecipienteEntrega: newTipo,
                },
            });
        } catch (error) {
            console.error('Erro ao alterar tipo de recipiente:', error);
        }
    }, [props, alterarTipoRecipienteEntrega]);
    const data = useTransformColeta({
        coletas: props.response,
        permissoes,
        totalEntregadorEscalado: totalEscalado,
        timeAdicionalCollectt: props.timeAdicionalCollectt,
        timeEsperaEstabelecimento: props.timeEsperaEstabelecimento,
        configuracao,
        unidadeSelecionada,
        onToggleRecipiente,
    });
    const response = useMemo(() => {
        return {
            coletasSemPlayer: props.response.filter(
                ({ entregador, status }) =>
                    (!entregador || !entregador.id) &&
                    status && status.length > 0 &&
                    [1, 10, 11].indexOf(status[0].id) !== -1,
            ).length,
            coletasNaoConcluidas: props.response.filter(({ status }) => {
                return (
                    status && status.length > 0 &&
                    [2, 3, 4, 5, 8, 12].indexOf(status[0].id) !== -1
                );
            }).length,
            playersBusy: props.response
                .filter(({ status }) => {
                    return (
                        status && status.length > 0 &&
                        [1, 2, 3, 4, 5, 10, 11, 12].indexOf(status[0].id) !== -1
                    );
                })
                .map(({ entregador }) => entregador.id),
        };
    }, [props.response]);
    console.log(data.length);

    return (
        <>
            <ListTemplate
                addFilterDate={true}
                browserTitle="Listar coletas"
                colunas={colunas}
                data={data}
                {...props}
            />
            {permissoes.perfilAdministrador && (
                <ModalInfoPlayer
                    {...response}
                    connection={props.entregadoresConnection}
                    totalColetas={data.length}
                />
            )}
        </>
    );
};
export default ListCollection;
